<template>
  <header id='sgheader'>
    <!-- <img src="/dist/img/logo_jwj@2x.png" alt="" class='logo'> -->
    <img :src="require('@/assets/img/icon_logo.png')" alt="" class='logo'>
    <!-- <Select v-model="schoolItem" class='schoolSelect' clearable  filterable @on-change='changeSchool' v-if='schoolList.length>1'>
        <Option v-for="item in schoolList" :value="item.id" :key="item.id">{{ item.name }}</Option>
    </Select> -->


    <div class='headRight'>
      <Menu mode="horizontal" ref='user' :active-name='activeHead' @on-select='changeHeadItem'>
        <MenuItem v-for='(item, index) in header' :name="index + ''" :key='item.id' :to='item.url'>
        {{ item.name }}
        </MenuItem>
        <!-- <MenuItem  name="3" to='/goodslist'>
					电商平台
				</MenuItem >
        <MenuItem  name="5" to='/appuser'>
          APP管理
        </MenuItem >
        <MenuItem  name="2" to='/canteenUselist'>
          食堂消费
        </MenuItem >
				<MenuItem   name="4" to='/appcenter'>
					应用中心
				</MenuItem > -->

      </Menu>
      <svg width=20 height=20 class='svgpic' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M547.4 197.4v46l200.3 0.1L546.1 444l32.4 32.6 201.9-200.7v200.9h46V197.5zM471.4 584.4l-32.6-32.6L243.6 747V547.9h-46v278.7h279v-46H275z" />
      </svg>

      <Dropdown trigger="click" @on-click='tabnews'>
        <svg width=20 height=20 class='svgpic' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          style='cursor:pointer'>
          <path
            d="M803.3 629c-4.6-5.6-8.9-10.8-12.5-15.3v-194c0-72.1-29-139.8-81.7-190.7-24.6-23.8-53.1-42.5-84-55.7-0.6-60.7-50.1-109.9-110.9-109.9-60.5 0-109.9 48.7-110.9 109-31.7 13.2-60.9 32.3-86.1 56.6-52.7 50.9-81.7 118.6-81.7 190.7v193.2c-3.8 4.7-8.3 10.1-13.2 16.1-62.2 75.7-93.8 120-93.8 152.1 0 23.8 10.3 38.3 18.9 46.3 16.2 15.1 36.6 16.9 45.7 16.9h2.5l180.6-0.2c10.7 65.5 67.6 115.6 136.1 115.6s125.4-50.1 136.1-115.6l181.7 0.2h2.5c9.1 0 29.5-1.9 45.7-16.9 8.6-8 18.9-22.6 18.9-46.3-0.1-32.1-31.7-76.4-93.9-152.1zM514.2 127.4c18.5 0 34.6 10.8 42.2 26.4-14.2-2.1-28.6-3.2-43.2-3.2-13.8 0-27.5 1-41 2.9 7.7-15.5 23.6-26.1 42-26.1z m-1.9 768.2c-33 0-61-21.8-70.5-51.7l71-0.1 70 0.1c-9.5 29.9-37.5 51.7-70.5 51.7zM832 780.2h-1.2l-251.4-0.3c-1.1-0.1-2.2-0.2-3.3-0.2l-63.3 0.1-63.3-0.1c-1.1 0-2.2 0.1-3.3 0.2l-251.4 0.3c-1.1 0-1-0.1-1.8 0 1.5-4.5 6.9-17 26.8-44.6 16.4-22.7 36.2-46.7 52-66 8.6-10.5 16.1-19.6 21.2-26.2 5.2-6.8 7.2-15 6.4-22.9 0.1-1.2 0.2-2.5 0.2-3.7V419.6c0-113.1 95.8-205.1 213.6-205.1s213.6 92 213.6 205.1v197.9c-1.8 8.8 0.1 18.2 5.9 25.9 5.1 6.6 12.5 15.7 21.2 26.2 15.9 19.3 35.6 43.3 52 66 19.9 27.6 25.4 40.2 26.8 44.6h-0.7z" />
        </svg>
        <Dropdown-menu slot="list">
          <Dropdown-item :name='index' :key='index' v-for='(item, index) in newslists'>{{ item.title }}</Dropdown-item>


        </Dropdown-menu>
      </Dropdown>
      <p class='line'></p>

      <Dropdown trigger="click" @on-click='tapDropdown'>
        <a href="javascript:void(0)">
          <img :src="avatar" alt="" class='avatar' v-if='avatar'>
          <img src="/dist/img/a0.jpg" alt="" class='avatar' v-else>
          <Icon type="arrow-down-b"></Icon>
        </a>
        <Dropdown-menu slot="list">
          <Dropdown-item name='changePWD'>修改密码</Dropdown-item>
          <Dropdown-item name='logout'>退出登录</Dropdown-item>

        </Dropdown-menu>
      </Dropdown>
    </div>
    <Modal v-model="logout" title="" @on-ok='logoutRole'>
      <div>是否退出？</div>
    </Modal>
    <Modal v-model='showpwd' title='修改密码'>
      <Form label-position="top" ref='formCustom'>
        <FormItem label="原始密码">
          <Input v-model="oldpwd" type='password' placeholder="请输入..."></Input>
        </FormItem>
        <FormItem label="新密码">
          <Input v-model="newpwd" type='password' placeholder="请输入..." @on-blur='getPwd'></Input>
        </FormItem>
        <FormItem label="确认新密码">

          <Input v-model="conformpwd" type='password' placeholder="请输入..."></Input>
        </FormItem>


      </Form>
      <div slot="footer" style='position:relative;'>
        <Button type="default" @click='showpwd = false' icon="md-close">取消</Button>
        <Button type="info" @click='addData' icon="md-checkmark-circle-outline">提交</Button>
      </div>
    </Modal>
  </header>
</template>

<script>
export default {
  name: 'sgheader',
  watch: {
    newslist: function (newval, oldval) {
      this.newslists = newval
    }
  },
  props: {
    newslist: {
      type: Array,
      default: () => { },
    }
  },
  data () {
    return {
      value7: true,
      schoolItem: '',
      schoolList: [],
      visible: false,
      theme1: 'light',
      theme3: 'light',
      curIndex: 1,
      logout: false,
      activeHead: '0',
      avatar: '',
      showpwd: false,
      oldpwd: '',
      newpwd: '',
      conformpwd: '',
      header: [],
      newslists: this.newslist
    }
  },
  created () {

  },
  mounted () {
    var that = this
    this.header = JSON.parse(localStorage.getItem('inchheadermenu'))

    that.$nextTick(() => {
      that.activeHead = localStorage.getItem('inchHeadAct') || '0'
      that.$refs.user.updateActiveName()

    })
    var inchUser = JSON.parse(localStorage.getItem('inchUserinfo'))

    if (inchUser.pic) {
      this.avatar = inchUser.pic
    }

    // utils.getSchoolData().then(res =>{
    // 	var _data = JSON.parse(res)
    //   that.schoolList = _data


    //     that.schoolItem = Number(localStorage.getItem('curSchoolid')) || _data[0]['id']
    //     localStorage.setItem('curSchoolid', that.schoolItem)



    // })
    //  this.$bus.$on('passProductType', (data) => {
    //   that.newslist = data
    // })
    this.newslists = localStorage.getItem('jwjNews') ? JSON.parse(localStorage.getItem('jwjNews')) : []
  },
  methods: {
    tabnews (e) {

      this.$emit('tabnewsindex', e)
    },
    showNewsList () {
      console.log(localStorage.getItem('jwjNews'))
      this.newslists = JSON.parse(localStorage.getItem('jwjNews'))
      // this.$bus.$on('passProductType', (data) => {
      //   console.log(data, '传递的数据')
      // })
    },
    getPwd () {

      var pwdRegex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,30}$');

      if (!pwdRegex.test(this.newpwd)) {
        this.$Message.info("您的密码复杂度太低（密码中必须包含大小写字母、数字、特殊字符）");
      }
    },
    addData () {
      var that = this
      if (this.oldpwd == '') {
        this.$Message.info('请输入旧密码')
        return false
      }
      if (this.newpwd == '') {
        this.$Message.info('请输入新密码')
        return false
      }
      if (this.conformpwd == '') {
        this.$Message.info('请重新输入新密码')
        return false
      }
      if (this.newpwd != this.conformpwd) {
        this.$Message.info('新密码不同')
        return false
      }
      var pwdRegex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,30}$');
      if (!pwdRegex.test(this.newpwd)) {
        this.$Message.info("您的密码复杂度太低（密码中必须包含大小写字母、数字、特殊字符）")
        return false;
      }
      this.axios.post('sys/modifypwd', {
        oldpwd: this.oldpwd,
        newpwd: this.newpwd,
        conformpwd: this.conformpwd
      }).then(res => {
        if (res.success) {
          that.$Message.success(res.msg)
          that.showpwd = false
          that.newpwd = ''
          that.conformpwd = ''
          that.oldpwd = ''
        } else {
          that.$Message.info(res.msg)
        }

      })
    },
    tapDropdown (e) {
      if (e == 'logout') {
        this.instance()
      } else {
        this.changePWD()
      }
    },
    changePWD () {
      this.showpwd = true
    },
    changeSchool (e) {

      localStorage.setItem('curSchoolid', String(e))
      this.$emit('changeSchoolInfo', e)
    },
    logoutRole () {
      var username = localStorage.getItem('jwjcurUsername')
      var password = localStorage.getItem('jwjcurUserpwd')
      var newslist = localStorage.getItem('jwjNews')
      localStorage.clear()
      localStorage.setItem("jwjcurUsername", username)
      localStorage.setItem("jwjcurUserpwd", password)
      localStorage.setItem('jwjNews', newslist)
      this.$router.push("/login")
    },
    changeHeadItem (e) {

      var _index = e
      localStorage.setItem('inchHeadAct', e)
      localStorage.setItem('inchcurTab', e)
      localStorage.setItem('inchleftcurIndex', 0)
    },
    instance () {

      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否退出登录？</p>',
        onOk: () => {
          this.logoutRole()
        },
        onCancel: () => {

        }
      });
    }
  }
}
</script>

<style scoped>
>>>.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  color: #515a6e;
  font-size: 14px;
  line-height: 76px;
}

>>>.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  font-size: 14px;
  color: #E22A1C;

  border-bottom: 3px solid #E22A1C;
  background: rgba(226, 42, 28, 0.05);

}

#sgheader {
  width: 100%;
  background: #fff;
  padding: 0px 20px 0px 0px;
  overflow: visible;
  justify-content: space-between;
  box-shadow: 0px 2px 10px 0px rgba(229, 229, 229, .5);
  position: fixed;
  top: 0px;
  z-index: 100
}

#sgheader .logo {
  width: 230px;
  margin-top: 18px;
  float: left;
  margin-left: 25px;
}

#sgheader .headRight {
  display: flex;
  justify-content: space-between;
  height: 65px;
  float: right;
}

#sgheader .ivu-menu-horizontal {
  height: 65px;
  line-height: 65px;
}

#sgheader .ivu-menu-horizontal .ivu-MenuItem {
  margin-left: 20px;
}

#sgheader .ivu-menu-vertical .ivu-MenuItem {
  padding-left: 35px;
  padding-top: 10px;
  padding-bottom: 10px;
}

#sgheader .ivu-menu-vertical .ivu-MenuItem-active {
  font-weight: bold;
}

#sgheader .ivu-menu-vertical .ivu-MenuItem-group-title {
  height: 0px;
}

#sgheader .avatar {
  width: 30px;
  height: 30px;
  margin-left: 20px;
  margin-top: 23px;
  cursor: pointer;
  border-radius: 50%;
}

#sgheader .ivu-menu-horizontal .ivu-menu-item {
  margin-left: 20px;
  font-weight: bold;
}

#sgheader .line {
  width: 2px;
  height: 20px;
  background: #f0f0f0;
  margin-left: 20px;
  margin-top: 28px;
}

#sgheader .svgpic {
  margin-left: 40px;
  margin-top: 28px;
}

.schoolSelect {
  float: left;
  margin-top: 30px;
  border: 0 none;
  width: 220px;
  margin-left: 50px;
  padding-left: 10px;
}

/* >>> .ivu-select-selection{
    border:0 none;
  }
  >>> .ivu-select-visible .ivu-select-selection{
    box-shadow:0  0 0 0
  }
  >>> .ivu-select-dropdown{
     min-width:900px!important;
     left:30px!important;
     z-index:1000;
  }
  >>> .ivu-select-dropdown-list .ivu-select-item{
    display:inline-block!important;
    float:left!important;
    clear:none!important;
    min-width:240px;
  } */
</style>
